import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const en = {
  nav: {
    home: "Home",
    games: "Games",
    teams: "Teams",
    players: "Players",
    leaders: "Leaders",
    admin: "Admin",
    operator_login: "Operator Login",
    login: "Login",
  },
  home: {
    hero_eyebrow: "FIBA 3×3 Live Statistics",
    live_now: "Live now",
    tournaments_label: "Tournaments",
    on_the_schedule: "On the schedule",
    upcoming: "Upcoming",
    just_played: "Just played",
    latest_results: "Latest results",
    view_all: "View all",
    top_scorers: "Top scorers",
    tournaments_side: "Tournaments",
    no_data: "No data yet",
    no_tournaments: "No tournaments yet",
    no_finished: "No finished games yet. Operators — start one from the live console.",
    see_more: "See",
  },
  games: {
    title: "Games",
    subtitle: "All scheduled, live and finished games",
    filter_all: "All",
    filter_live: "Live",
    filter_upcoming: "Upcoming",
    filter_finished: "Finished",
    empty: "No games found",
    filter_tournament: "Tournament",
    filter_tournament_all: "All tournaments",
    open_boxscore: "Open box score",
  },
  teams: {
    title: "Teams",
    subtitle: "Every squad on the floor",
    empty: "No teams yet",
    view_roster: "View roster",
    roster: "Roster",
  },
  players: {
    title: "Players",
    subtitle: "Every athlete in the league",
    empty: "No players yet",
    game_log: "Game log",
    per_game: "Per game",
    games: "Games",
    shooting: "Shooting",
  },
  leaders: {
    title: "Leaders",
    subtitle: "Tournament-wide rankings across every category",
    subtitle_filtered: "Rankings filtered by {{name}}",
    per_game_label: "Per game",
    games_label: "Games",
  },
  game: {
    back_to_games: "All games",
    box_score: "Box Score",
    box_score_pdf: "Box Score",
    pbp: "PBP",
    play_by_play: "Play-by-Play",
    scoreboard: "Scoreboard",
    fouls: "Fouls",
    bonus_active: "⚠ Bonus 7+ active",
    overtime: "Overtime",
    regulation: "Regulation 10 min",
    events_none: "No events recorded yet.",
    team_totals: "Team",
    legend: "Legend",
  },
  common: {
    live: "Live",
    final: "Final",
    upcoming: "Upcoming",
    tournament: "Tournament",
    portal: "Portal",
    loading: "Loading…",
    season: "Season",
    view: "View",
  },
  tournament: {
    label: "Tournament",
    teams_count: "{{count}} Teams",
    players_count: "{{count}} Players",
    games_count: "{{count}} Games",
    not_found_title: "Tournament not found",
    not_found_hint: "The link may be broken or the tournament may have been archived.",
    back_to_portal: "Back to portal",
    no_games: "No games yet.",
    no_teams: "No teams yet.",
    no_players: "No players yet.",
    no_leaders: "No data for this metric yet.",
  },
  footer: {
    default_tagline: "Professional live statistics platform for FIBA 3×3 competitions. Built for operators, federations and fans.",
    explore: "Explore",
    operator_col: "Operator",
    admin_panel: "Admin Panel",
    built_for: "© GPS STATS · BUILT FOR 3×3",
  },
};

const pt = {
  nav: {
    home: "Início",
    games: "Jogos",
    teams: "Equipes",
    players: "Atletas",
    leaders: "Ranking",
    admin: "Admin",
    operator_login: "Login Operador",
    login: "Entrar",
  },
  home: {
    hero_eyebrow: "Estatísticas ao Vivo FIBA 3×3",
    live_now: "Ao vivo",
    tournaments_label: "Torneios",
    on_the_schedule: "Na agenda",
    upcoming: "Próximos jogos",
    just_played: "Recém-jogados",
    latest_results: "Últimos resultados",
    view_all: "Ver todos",
    top_scorers: "Cestinhas",
    tournaments_side: "Torneios",
    no_data: "Sem dados ainda",
    no_tournaments: "Sem torneios ainda",
    no_finished: "Sem jogos encerrados. Operadores — iniciem um no console ao vivo.",
    see_more: "Ver",
  },
  games: {
    title: "Jogos",
    subtitle: "Todos os jogos agendados, ao vivo e encerrados",
    filter_all: "Todos",
    filter_live: "Ao vivo",
    filter_upcoming: "Próximos",
    filter_finished: "Encerrados",
    empty: "Nenhum jogo encontrado",
    filter_tournament: "Torneio",
    filter_tournament_all: "Todos os torneios",
    open_boxscore: "Abrir Box Score",
  },
  teams: {
    title: "Equipes",
    subtitle: "Cada esquadrão em quadra",
    empty: "Nenhuma equipe cadastrada",
    view_roster: "Ver elenco",
    roster: "Elenco",
  },
  players: {
    title: "Atletas",
    subtitle: "Todos os jogadores da liga",
    empty: "Nenhum atleta cadastrado",
    game_log: "Histórico de jogos",
    per_game: "Por jogo",
    games: "Jogos",
    shooting: "Arremesso",
  },
  leaders: {
    title: "Ranking",
    subtitle: "Rankings por categoria em todos os torneios",
    subtitle_filtered: "Rankings filtrados por {{name}}",
    per_game_label: "Por jogo",
    games_label: "Jogos",
  },
  game: {
    back_to_games: "Todos os jogos",
    box_score: "Box Score",
    box_score_pdf: "Box Score",
    pbp: "PBP",
    play_by_play: "Play-by-Play",
    scoreboard: "Placar",
    fouls: "Faltas",
    bonus_active: "⚠ Bônus 7+ ativo",
    overtime: "Prorrogação",
    regulation: "Tempo normal 10 min",
    events_none: "Nenhum evento registrado ainda.",
    team_totals: "Equipe",
    legend: "Legenda",
  },
  common: {
    live: "Ao vivo",
    final: "Final",
    upcoming: "Próximo",
    tournament: "Torneio",
    portal: "Portal",
    loading: "Carregando…",
    season: "Temporada",
    view: "Ver",
  },
  tournament: {
    label: "Torneio",
    teams_count: "{{count}} Equipes",
    players_count: "{{count}} Atletas",
    games_count: "{{count}} Jogos",
    not_found_title: "Torneio não encontrado",
    not_found_hint: "O link pode estar quebrado ou o torneio pode ter sido arquivado.",
    back_to_portal: "Voltar ao portal",
    no_games: "Sem jogos ainda.",
    no_teams: "Sem equipes ainda.",
    no_players: "Sem atletas ainda.",
    no_leaders: "Sem dados para esta métrica ainda.",
  },
  footer: {
    default_tagline: "Plataforma profissional de estatísticas ao vivo para competições FIBA 3×3. Feita para operadores, federações e torcedores.",
    explore: "Explorar",
    operator_col: "Operador",
    admin_panel: "Painel Admin",
    built_for: "© GPS STATS · CONSTRUÍDO PARA 3×3",
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { en: { translation: en }, "pt-BR": { translation: pt }, pt: { translation: pt } },
    fallbackLng: "pt-BR",
    supportedLngs: ["en", "pt-BR", "pt"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "gps-lang",
    },
  });

export default i18n;
